<script>
import { formatGetTime } from '@utils/format-date'
export default {
  computed: {
    /**
     * @description 備註名稱
     */
    labelIndex() {
      let index = Math.abs(this.paginationIndex % this.columnForShow.length) || 0
      this.labelName = this.columnForShow[index]
      return index
    },
    /**
     * @description 因為localStorage有可能有多的品項，所以要刪掉來顯示只要顯示的
     * notice：這邊不用改多語系，使用程式區分
     */
    columnForShow() {
      let allColumn = ['客戶備註', '寵物備註', '服務備註', '使用人備註']
      if (!this.$merchantI18n() === 'pet') {
        allColumn = allColumn.filter(item => item !== '寵物備註')
      }
      return this.columnShowList.filter(item => allColumn.includes(item))
    }
  },
  data() {
    return {
      paginationIndex: 0,
      serviceRemark: [
        { label: '需要接送服務嗎？', context: '測試文字測試文字測試文字測試文字' },
        { label: '請問是否毛多？', context: '測試文字測試文字測試文字測試文字' },
        { label: '使用人備註', context: '測試文字測試文字測試文字測試文字' },
      ],
      labelName: '',
      serviceComment: [],
      petComment: [],
      memberComment: [],
      customComment: [],
      memberInfo: {}
    }
  },
  watch: {
    openRemarkInfo(nvl) {
      this.initComment()
      const { serviceComments, pet, member, note } = nvl
      // 寵物備註
      if (pet && pet.petComments.items.length) {
        pet.petComments.items.sort((a, b) => new Date(formatGetTime(b.updatedAt)) - new Date(formatGetTime(a.updatedAt)))
        let object = pet.petComments.items[0]
        object.showDay = object.createdAt.split(' ')
        this.petComment.push(object)
      }
      // 服務備註
      if (serviceComments && serviceComments.items.length) {
        serviceComments.items.sort((a, b) => new Date(formatGetTime(b.updatedAt)) - new Date(formatGetTime(a.updatedAt)))
        let object = serviceComments.items[0]
        object.showDay = object.createdAt.split(' ')
        object.handleT = (serviceComments.items[0].questions.handle.map(item => item)).join('，')
        this.serviceComment.push(object)
      }
      // 客戶備註
      if (member && member.memberPrivateComments.items.length) {
        member.memberPrivateComments.items.sort((a, b) => new Date(formatGetTime(b.updatedAt)) - new Date(formatGetTime(a.updatedAt)))
        let object = member.memberPrivateComments.items[0]
        object.showDay = object.createdAt.split(' ')
        this.memberComment.push(object)
      }
      // 使用者備註
      if (note && note.length) {
        this.$set(this.memberInfo, 'tempNote', note.split('\n'))
        this.$set(this.memberInfo, 'fullName', nvl.fullName)
        this.$set(this.memberInfo, 'genderTitle', nvl.gender === 'male' ? '先生' : '小姐')
        this.$set(this.memberInfo, 'phoneCode', nvl.phoneCode)
        this.$set(this.memberInfo, 'phoneNumber', nvl.phoneNumber)
      }
    }
  },
  mounted() {

  },
  props: {
    columnShowList: {
      type: Array,
    },
    openRemarkInfo: {
      type: Object
    }
  },
  methods: {
    prev() {
      this.paginationIndex--
    },
    next() {
      this.paginationIndex++
    },
    initComment() {
      this.serviceComment = []
      this.petComment = []
      this.memberComment = []
      this.customComment = []
      this.memberInfo = {}
    },
    afterOrder(questions) {
      let string = []
      questions.afterOrder.forEach((item) => {
        if (item === '正常') {
          string.push('正常')
        }
        if (item === '皮膚病') {
          string.push('皮膚病')
        }
        if (item === '指甲流血') {
          string.push('指甲流血')
        }
        if (item === '剃傷') {
          string.push('剃傷')
        }
        if (item === '跳蚤') {
          let text = ''
          if (questions.afterOrderOption[0]) {
            text = `跳蚤(${questions.afterOrderOption[0]})`
          } else {
            text = '跳蚤'
          }

          string.push(text)
        }
        if (item === '璧蝨') {
          let text = ''
          if (questions.afterOrderOption[1]) {
            text = `璧蝨(${questions.afterOrderOption[1]})`
          } else {
            text = '璧蝨'
          }
          string.push(text)
        }
        if (item === '耳炎') {
          let text = ''
          if (questions.afterOrderOption[2]) {
            text = `耳炎(${questions.afterOrderOption[2]})`
          } else {
            text = '耳炎'
          }
          string.push(text)
        }
        if (item === '耳疥') {
          let text = ''
          if (questions.afterOrderOption[3]) {
            text = `耳疥(${questions.afterOrderOption[3]})`
          } else {
            text = '耳疥'
          }
          string.push(text)
        }
        if (item === '眼睛') {
          let text = ''
          if (questions.afterOrderOption[4].length > 0) {
            text = `眼睛(${questions.afterOrderOption[4].join(',')})`
          } else {
            text = '眼睛'
          }
          string.push(text)
        }
      })
      return string.join('，')
    },
  }
}
</script>
<template>
  <div>
    <div :class="$style.pagination">
      <el-button @click="prev" class="is-no-style">
        <BaseIcon name="angle-left" class="anl" />
      </el-button>
      <div>{{ columnForShow[labelIndex] }}</div>
      <el-button @click="next" class="is-no-style">
        <BaseIcon name="angle-right" class="anr" />
      </el-button>
    </div>
    <div v-if="labelName === '客戶備註'" :class="$style.paginationContext">
      <div v-for="item in memberComment" :key="item.id">
        <p class="mainContext">{{ item.content }}</p>
        <p class="date">- {{ item.showDay[0] }} {{ item.creator.name }}</p>
        <div class="only-bottom-line" style="margin-top:12px;margin-bottom:24px"></div>
      </div>
    </div>
    <div v-if="labelName === '寵物備註' && $merchantI18n() === 'pet'" :class="$style.paginationContext">
      <div v-for="item in petComment" :key="item.id">
        <p class="mainContext">{{ item.content }}</p>
        <p class="date">- {{ item.showDay[0] }} {{ item.creator.name }}</p>
        <div class="only-bottom-line" style="margin-top:12px;margin-bottom:24px"></div>
      </div>
    </div>
    <div v-if="labelName === '使用人備註'" :class="$style.paginationContext2">
      <p class="label" v-if="memberInfo.fullName">使用人資訊</p>
      <p class="main">{{ memberInfo.fullName }} {{ memberInfo.genderTitle }}</p>
      <p>{{ memberInfo.phoneCode }} {{ memberInfo.phoneNumber }}</p>
      <div style="padding-top:8px;" v-for="item, index in memberInfo.tempNote" :key="index">
        <p class="comment1">{{ item }}</p>
      </div>
      <div v-if="memberInfo.fullName" class="only-bottom-line obl"></div>

    </div>
    <div v-if="labelName === '服務備註'" :class="$style.paginationContext3">
      <div class="imgGroup" v-if="serviceComment.length > 0">
        <div v-for="imagesSrc in serviceComment[0].images">
          <img :src="imagesSrc" style="width:70px;height:70px;" />
        </div>
      </div>
      <div v-for="item in serviceComment">
        <p class="context1">{{ afterOrder(item.questions) }}</p>
        <p class="context3">{{ item.handleT }}</p>
        <p class="context2">{{ item.content }}</p>
        <p class="date">- {{ item.showDay[0] }} {{ item.creator.name }}</p>
        <div class="only-bottom-line" style="margin-top:12px;margin-bottom:24px"></div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
}

.paginationContext {
  margin-top: 21px;
  width: 100%;

  :global {
    p {
      margin: 0;
    }

    .mainContext {
      white-space: pre-line;
      text-align: left;
      color: $color-secondary;
      line-height: 24px;
      margin-bottom: 24px;
    }

    .date {
      text-align: left;
      color: $color-state-service;
    }
  }
}

.paginationContext2 {
  p {
    margin: 8px auto;
  }

  :global {
    .obl {
      padding-top: 6px;
      padding-bottom: 6px;
    }

    .label {
      color: $color-text-light;
    }

    .main {
      color: $color-secondary;
    }

    .comment1 {
      color: $color-secondary;

      &::before {
        content: '使用人備註：';
        color: $color-state-service;
      }
    }
  }
}

.paginationContext3 {

  // display: flex;
  // justify-content: center;
  :global {
    .imgGroup {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .context1 {
      color: $color-secondary;

      &::before {
        content: '美容後問題：';
        color: $color-state-service;
      }
    }

    .context3 {
      color: $color-secondary;

      &::before {
        content: '善後處理：';
        color: $color-state-service;
      }
    }

    .context2 {
      color: $color-secondary;

      &::before {
        content: '備註：';
        color: $color-state-service;
      }
    }
  }
}
</style>



